<template>
    <div class="integration-charges">
        <legend>Transaction Ledger</legend>
        <div v-if="integrationCharges.length === 0 && !loading">
            No transactions to display
        </div>
        <div v-else-if="!loading">
            <h5><i class="fa fa-info-circle"></i> <i>Note:</i> Transactions generated by Onboard have "Notes" that begin with [onboardrs]</h5><br>
            <div v-for="(charge) in integrationCharges" :key="charge.id">
                <p>
                    <span v-if="charge.type === TYPE_CHARGE"><label class="label label-warning">Charge</label><br></span>
                    <span v-else-if="charge.type === TYPE_PAYMENT"><label class="label label-info">Payment</label><br></span>
                    Amount: <b>{{ `$${Math.round(charge.charge_cents / 100, 2)}` }}</b><br>
                    <span :style="[charge.notes ? {} : {color: '#949494'}]">Notes: <b>{{ charge.notes ? charge.notes : ' -' }}</b><br></span>
                    <span :style="[charge.charge_code_id ? {} : {color: '#949494'}]">Charge Code: {{ charge.charge_code_id ? charge.charge_code_id : ' -' }}<br></span>
                    <span :style="[charge.charge_code_description ? {} : {color: '#949494'}]">Charge Code Description: {{ charge.charge_code_description ? charge.charge_code_description : ' -' }}<br></span>
                    Post Month: {{ charge.post_month_at.substring(0, 10) }}<br>
                    <span :style="[charge.service_month_at ? {} : {color: '#949494'}]">Service Month: {{ charge.service_month_at ? charge.service_month_at.substring(0, 10) : "n/a" }}<br></span>
                    Status: {{ getDisplayStatus(charge.status) }}<br>
                    Unit: {{ charge.rent_roll_unit }}
                </p>
                <hr>
            </div>
        </div>
    </div>
</template>

<script>
    const STATUS_CREATED = 0;
    const STATUS_SUBMITTED = 1;
    const STATUS_UNKNOWN = 2;
    const STATUS_OPEN = 3;
    const STATUS_CLOSED = 4;

    const TYPE_CHARGE = 1;
    const TYPE_PAYMENT = 2;

    export default {
        props: {
            modalId: {
                default(){
                    return _.uniqueId( 'modal_' );
                },
                type: String
            },
            appUrl: {
                required: true,
                type: [String]
            },
            leaseId: {
                required: false,
                type: [String, null]
            },
            unitId: {
                required: false,
                type: [String, null]
            }
        },

        data(){
            return {
                loading: true,
                STATUS_CREATED,
                STATUS_SUBMITTED,
                STATUS_UNKNOWN,
                STATUS_OPEN,
                STATUS_CLOSED,
                TYPE_CHARGE,
                TYPE_PAYMENT,
                integrationCharges: [],
            };
        },

        mounted() {
            this.init();
        },

        computed: {
        },

        methods: {
            init() {
                this.loadIntegrationCharges()
                    .catch(this.$root.handleErrors)
                    .finally(() => this.loading = false)
            },

            loadIntegrationCharges() {
                if (this.leaseId || this.unitId) {
                    var url = this.appUrl + '/api/integrationCharges?'
                    if (this.leaseId) {
                        url += 'lease_id=' + this.leaseId;
                    }
                    if (this.unitId) {
                        if (this.leaseId) url += '&';
                        url += 'unit_id=' + this.unitId;
                    }
                    return axios.get( url )
                        .then(res => {
                            this.integrationCharges = res.data.sort((a, b) => (new Date(a.post_month_at) < new Date(b.post_month_at)) ? 1 : -1);
                        } )
                        .catch(err => {
                            if (err.response.data.error) {
                                this.$notify( {
                                    type: 'success',
                                    placement: 'top-left',
                                    title: err.response.data.data,
                                } );
                            }
                        })
                }
                else {
                    return Promise.resolve();
                }
            },

            // Helper functions / Computed values / etc
            getDisplayStatus(status) {
                status = parseInt(status)
                switch (status) {
                    case STATUS_CREATED:
                        return 'Generated / Not Submitted';
                    case STATUS_SUBMITTED:
                        return 'Submitted to Integration';
                    case STATUS_UNKNOWN:
                        return 'Unknown';
                    case STATUS_OPEN:
                        return 'Posted / Open';
                    case STATUS_CLOSED:
                        return 'Closed';
                }
            },

            getDisplayType(type) {
                type = parseInt(type)
                switch (type) {
                    case TYPE_CHARGE:
                        return 'Charge';
                    case TYPE_PAYMENT:
                        return 'Payment';
                }
            }
        }
    }
</script>
